import { getApiToken } from '@/utils/api';
import axios, { AxiosError } from 'axios';

axios.defaults.baseURL = import.meta.env.VITE_API_URL || 'http://localhost:8000';
axios.defaults.withCredentials = false;

const api = axios;

axios.interceptors.request.use(function (config) {
  const accessToken = getApiToken();
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  if (import.meta.env.VITE_ENVIRONMENT === 'local') {
    config.headers['ngrok-skip-browser-warning'] = '1234';
  }
  return config;
});

export type ApiError = AxiosError;
export const API_PREFIX = '/v1/admin';
export const V2_ADMIN_PREFIX = '/v2/admin';
export default api;
